export class StorageKeys {
  public static readonly token = 'TOKEN';
  public static readonly cart = 'CART-{restaurantId}{consumptionMode}';
  public static readonly restaurant = 'RESTAURANT';
  public static readonly language = 'LANG';
}
